/* {
  "airTemperature": "Air_temperature_average", "windSpeed": "Wind_speed_average", "humidity": "Relative_humidity_average", "dewPoint": "Dew_point_average"
 } */

const AIR_TEMPERATURE = 'Air Temperature C (act.)'
const WIND_SPEED = 'Wind Speed m/s (avg.)'
const HUMIDITY = 'Relative Humidity (avg.)'
const DEW_POINT = 'Dew Point C (avg.)'
const INSOLATION = 'IO_SENSOR1_DATA'

class Meteo {
  station

  constructor (station) {
    this.station = station
  }

  getInsolation () {
    if ((this.station.structure !== null) && this.station.structure.insolation) {
      return this.station.structure.insolation
    }
    return INSOLATION
  }

  getAirTemperature () {
    if ((this.station.structure !== null) && this.station.structure.airTemperature) {
      return this.station.structure.airTemperature
    }
    return AIR_TEMPERATURE
  }

  getWindSpeed () {
    if ((this.station.structure !== null) && this.station.structure.windSpeed) {
      return this.station.structure.windSpeed
    }
    return WIND_SPEED
  }

  getHumidity () {
    if ((this.station.structure !== null) && this.station.structure.humidity) {
      return this.station.structure.humidity
    }
    return HUMIDITY
  }

  getDewPoint () {
    if ((this.station.structure !== null) && this.station.structure.dewPoint) {
      return this.station.structure.dewPoint
    }
    return DEW_POINT
  }

  getId () {
    return this.station.meteo.meteo_station
  }

  getPlaneId () {
    return this.station.meteo.solar_plane
  }

  getHorizontalId () {
    return this.station.meteo.solar_horiz
  }
}

export default Meteo
